import { NAMES_ES } from "../../assets/appConstants/constants";
import CopyToClipboard from "../common/CopyToClipboard";
import { TableColumn } from "../../models/dataTable.model";
import { DataArea } from "../../models/area.model";
import './index.css'
import { Link } from "react-router-dom";


const TableSchema: TableColumn[] = [
  { key: 'code', name: NAMES_ES.code, width: '10%' },
  { key: 'name', name: NAMES_ES.name, width: '15%' },
  { key: 'created_date', name: NAMES_ES.created_date, width: '15%' },
  { key: 'phone_number', name: NAMES_ES.phone_number, width: '10%' },
  { key: 'company', name: NAMES_ES.company, width: '15%' },
  { key: 'description', name: NAMES_ES.description, width: '35%' },
]

const columnId: string = 'code'
const rowDetailPath = '/area/view/'

const rowDataPreprocesor = (rowData: any, project_code: string): any => {

  return {
    ...rowData,
    code_render: (
      <div className='area-table-column-id'>
        <span>
          <Link className="area-table-column-id__link" to={`/${project_code}${rowDetailPath}${rowData.code}`}>
            {rowData.code}
          </Link>
        </span>

        <div className='area-table-column-id__copyicon'>
          <CopyToClipboard targetText={rowData.code as string} />
        </div>
      </div>
    ),
  }
}

const handleDoubleClickRow = (project_code: string, area_code: string, navigate: any) => {
  navigate(`/${project_code}${rowDetailPath}${area_code}`)
}

export { TableSchema, columnId, rowDataPreprocesor, handleDoubleClickRow }